module.exports = __webpack_public_path__ + "img/magento-custom-development@2x.b5e0bd22.webp";